/**
 * Price formatting utilities
 */

/**
 * Formats a price according to the provided format string
 * @param price - The numeric price value
 * @param priceFormat - Format string containing placeholder for price (e.g., "€ 0,00")
 * @returns Formatted price string
 */
export const formatPrice = (price: number, priceFormat: string): string => {
    return priceFormat.replace(priceFormat.includes(',') ? '0,00' : '0.00', price.toFixed(2)).replace('.', ',');
};

/**
 * Formats old price for display, returns undefined if same as current price
 * @param oldPriceAmount - The old price amount
 * @param currentPriceAmount - The current price amount
 * @param priceFormat - Format string for price display
 * @returns Formatted old price string or undefined if not applicable
 */
export const formatOldPrice = (
    oldPriceAmount: number,
    currentPriceAmount: number,
    priceFormat: string,
): string | undefined => {
    if (oldPriceAmount === currentPriceAmount) {
        return undefined;
    }
    return formatPrice(oldPriceAmount, priceFormat);
};
